angular.module('app.general').filter('memoize', memoizeFilter);

function memoizeFilter() {
  return _.memoize(
    (value) => value,
    (value) => JSON.stringify(value),
  );
}
